<div class=" mt-4">
  <section class="my-4">
    <div class="scrollmenu">
      <a [routerLink]="['/pos/customer/manage']"> Customer </a>
      <a [routerLink]="['/pos/employee/manage']"> Employee </a>
      <a [routerLink]="['/pos/orders/manage']"> Orders </a>
      <a [routerLink]="['/pos/taxfee/manage']"> Tax-Fee </a>
      <a [routerLink]="['/pos/category/manage']"> Item-Category </a>
      <a [routerLink]="['/pos/item/manage']">Items </a>
      <a [routerLink]="['/pos/businesshour/manage']"> Business-Hours </a>
      <!-- <a [routerLink]="['/pos/ordertype/manage']"> Order-Type </a>
      <a [routerLink]="['/pos/payment/manage']"> Payment </a>
      <a [routerLink]="['/pos/tips/manage']">Tips </a> -->
<!--  
            <a [routerLink]="['/pos/order/manage']"> <i class="fa-1x mr-1 icon-img fas fa-receipt"></i>  Order
            </a>
      -->
      <!--  
            <a [routerLink]="['/pos/orderreceipt/manage']"> <img class="mr-1 icon-img" src="assets/img/order-recpit-icon.png" alt="customer-icon"/>Order Receipt
            </a>
      -->

      <!-- <a [routerLink]="['settlementvendors/manage']"> <i class="fa-1x mr-1 icon-img fas fa-briefcase"></i> Settlement vendors
            </a> -->
      <!--   <a [routerLink]="['/pos/tender/manage']">     <i class="fa fa-shopping-cart" aria-hidden="true"></i>   Tender </a>
          -->

    </div>
  </section>
  <section>


    <div class="row mb-3">
      <div class="col-md-12">
        <div class="float-right">
        
          <button class="btn dash-btns" type="button" id="NewTransaction"
          [routerLink]="['/pos/orderreceipt/new']"  >New Order Receipt</button> 
        </div>



      </div>
    </div>


 
    <div class="row">
      <div class="col-md-12 ">
        <ngx-datatable #table class='bootstrap no-detail-row' [scrollbarH]="true"   [footerHeight]="50" [rowHeight]="'auto'"[columnMode]="'force'" [limit]="10" [rows]="rows" >
          <ngx-datatable-column name="Action" [width]="200">
              <ng-template let-row="row" ngx-datatable-cell-template>
                  <a class="edit"
                      [routerLink]="['/pos/orderreceipt/view',{id : row.id}]"
                      data-toggle="tooltip" data-placement="top" title="View">
                      <img src="./assets/ViewDetails.svg">
                  </a>
                  <a class="edit" 
                  [routerLink]="['/pos/orderreceipt/edit',{id : row.id}]" 
                  data-toggle="tooltip" data-placement="top" title="Edit">
                      <em class="fa-1x mr-2 fas fa-edit"></em>
                  </a>
              </ng-template>
          </ngx-datatable-column>

            <ngx-datatable-column name="AddNoofBlankLineTopOfReceipt" [width]="300">
                <ng-template let-row="row" ngx-datatable-cell-template>{{row.addNoofBlankLineTopOfReceipt}} </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="OrderNumberType" [width]="300">
                <ng-template let-row="row" ngx-datatable-cell-template> {{row.orderNumberType}} </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="PosSubscriptionId" [width]="200">
                <ng-template let-row="row" ngx-datatable-cell-template> {{row.posSubscriptionId}} </ng-template>

            </ngx-datatable-column>
          
        </ngx-datatable>
      </div>
    </div>
  </section>
</div>
<!-- <section >
    <div class="block-header">
      <div class="">
        <div class="row ">
          <div class="col-md-12 p-0">
            <h2 class="poppins font-weight-bold ">Order Receipt</h2>
          </div>
          <div class=" col-md-5 px-6 col-sm-12 p-0">
  
            <div class="breadcrumb flat">
                <a [routerLink]="['/pos']">Home</a>
                <a href="#" class="active">Order Receipt </a>
            </div>
          </div>
          <div class="col-md-7">
            <div class="float-right"> 
  
            </div>
          </div>
  
        </div>
      </div>
  
    </div>
    <div class="container  ">
  
  
  
      <div class="row">
        <div class="col-md-12 p-0">
          <div class=" card px-5 py-4 poppins border" style="box-shadow: none; border-radius: 10px;">
     
          </div>
        </div>
      </div>
    </div>
  </section> -->
 